import React from "react";
import {Col} from "react-bootstrap";
import {useSelector} from "react-redux";
import {getSelectedAnimalForDocuments} from "../../../selectors/animalDocumentsSelectors";
import GroupMortality from "../group-mortality/GroupMortality";
import GainChart from "./charts/GainChart";
import LocationChart from "./charts/LocationChart";

const EventCharts = ({loading}) => {
    const group = useSelector(getSelectedAnimalForDocuments);
    if (!group?.AnmGrp) return null;
    return (
        <Col xs={12}>
            <GainChart />
            <GroupMortality loading={loading} />
            {/* <FallHistogram /> */}
            <LocationChart />
        </Col>
    );
};

export default EventCharts;
